<template>
  <div class="template limitVisitorsIP">
    <el-form>
      <el-form-item>
        <el-button type="primary" @click="addPop">{{$t('im.bt.add')}}</el-button>
        <el-button @click="deleteAllPop">{{$t('im.bt.delete')}}</el-button>
      </el-form-item>
    </el-form>
    <el-table border :data="tableList" tooltip-effect="dark" style="width: 100%" @selection-change="selectionVisitorsIP">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column :prop="itemTabNav.id" :label="itemTabNav.name" v-for="itemTabNav in tableNav" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column :label="$t('im.bt.operator')">
        <template slot-scope="scope">
          <el-button size="mini" @click="editVisitorsIPPop(scope.row)">{{$t('im.bt.update')}}</el-button>
          <el-button size="mini" type="danger" @click="deletePop(scope.row)">{{$t('im.bt.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flexEnd" v-if="totalNum>0">
      <el-pagination
        background
        @size-change="pageSizeChange"
        @current-change="currentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </div>
    <el-dialog :title="$t('im.limitVisitorsIP.addLimit')" :visible.sync="isToOftenPop">
      <el-form class="div_form" label-width="100px">
        <el-form-item :label="$t('im.common.bizCodeName')">
          <el-select v-model="businessGroupCode" :placeholder="$t('im.common.placeholderBizCodeName')">
            <el-option
              v-for="item in businessGroupData"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.limitVisitorsIP.limitType')">
          <el-radio v-model="radioTxt" label="0" @change="visitorsIPType">{{$t('im.limitVisitorsIP.ip')}}</el-radio>
          <el-radio v-model="radioTxt" label="1" @change="visitorsIPType">{{$t('im.limitVisitorsIP.account')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('im.limitVisitorsIP.limitTypeCon')">
          <el-input v-model="radioContent" :placeholder="$t('im.limitVisitorsIP.placeholderLimitType')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('im.limitVisitorsIP.limitReason')">
          <el-input type="textarea" :rows="2" v-model="contentTxt"></el-input>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" @click="submitSave">{{$t('im.bt.definite')}}</el-button>
        <el-button @click="isToOftenPop=false">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  require('@/styles/IM/template.css')
  import apiDeployManagement from '@/api/im/deployManagement'
  import Util from '@/utils/IM/tradeDataUtil'
  import { localRead } from '@/utils/tools'

  export default {
    name: 'limitVisitorsIP',
    data() {
      return {
        util: Util,
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize:10, //当前页条数数
        tableList: [],  //当前资源列表
        tableNav: [
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.limitVisitorsIP.ip'), id: 'IPContent' },
          { name: window.$t('im.limitVisitorsIP.account'), id: 'accountContent' },
          { name: window.$t('im.limitVisitorsIP.limitReason'), id: 'remark' }
        ],  //当前资源列表头部
        resourceID: '',//当前数据ID
        resourceType: '',//0：新增，1：编辑
        isToOftenPop: false,  //弹窗是否显示
        oftenTitle: window.$t('im.limitVisitorsIP.addLimit'),  //标题
        contentTxt: '',  //阻止原因
        radioTxt: '0',   //选择IP或账户
        radioContent: '',  //IP或账户内容
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCode: '',  //弹窗业务编码Code
        bizCodes:[],//业务编码组
        multipleSelection: []  //选择条数集合
      }
    },
    methods: {
      /*初始化业务组tab*/
      initBusinessGroup() {
        if (this.businessGroupData.length > 0) {
          this.businessGroupCode = this.businessGroupData[0].code
          for (const i in this.businessGroupData) {
            let code = this.businessGroupData[i].code
            this.bizCodes.push(code)
          }
        }
      },
      /*选择资源*/
      selectionVisitorsIP(val) {
        let data = []
        if (val.length > 0) {
          for (const i in val) {
            data.push(val[i].id)
          }
          this.multipleSelection = data
        } else {
          this.multipleSelection = []
        }
      },
      /*选择账户或IP*/
      visitorsIPType(data) {
        this.radioTxt = data
      },
      /*修改当前*/
      editVisitorsIPPop(data) {
        this.isToOftenPop = true
        this.resourceType = 1
        this.oftenTitle = window.$t('im.limitVisitorsIP.updateLimit')
        this.resourceID = data.id
        this.radioTxt = data.accountType.toString()
        this.contentTxt = data.remark
        this.radioContent = data.account
        this.businessGroupCode = data.bizCode
      },
      /*删除弹窗*/
      deletePop(row) {
        this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
          confirmButtonText: window.$t('im.bt.definite'),
          cancelButtonText: window.$t('im.bt.cancel'),
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteVisitorsIP(row)
        }).catch(() => {
          this.$message.info(window.$t('im.common.cancelDel'))
        })
      },
      /*删除当前*/
      deleteVisitorsIP(row) {
        let data = { id: row.id }
        apiDeployManagement.deleteConAccessLimit(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            this.initVisitorsIP()
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*删除所有弹窗*/
      deleteAllPop() {
        if (this.multipleSelection.length > 0) {
          this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
            confirmButtonText: window.$t('im.bt.definite'),
            cancelButtonText: window.$t('im.bt.cancel'),
            type: 'warning',
            center: true
          }).then(() => {
            this.deleteAllVisitorsIP()
          }).catch(() => {
            this.$message.info(window.$t('im.common.cancelDel'))
          })
        }
      },
      /*删除所有*/
      deleteAllVisitorsIP() {
        let data = { ids: this.multipleSelection.join(',') }
        apiDeployManagement.deleteBatchConAccessLimit(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            this.initVisitorsIP()
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*新建主题弹窗*/
      addPop() {
        this.isToOftenPop = true
        this.resourceType = 0
        this.oftenTitle = window.$t('im.limitVisitorsIP.addLimit')
        this.radioTxt = '0'
        this.contentTxt = ''
        this.radioContent = ''
      },
      /*切换分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          companyId: this.userInfo.companyId,
          pageSize: val,
          pageNum: this.currentPage,
        }
        this.getVisitorsIP(data)
      },
      /*切换当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: val,
          pageSize: this.pageSize,
        }
        this.getVisitorsIP(data)
      },
      /*获取数据*/
      getVisitorsIP(data){
        apiDeployManagement.queryConAccessLimitListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result.list) {
              let newData = JSON.parse(JSON.stringify(res.result.list))
              this.totalNum = res.result.total
              for (const i in newData) {
                for (const j in this.businessGroupData) {
                  if (this.businessGroupData[j].code == newData[i].bizCode) {
                    newData[i].bizCodeName = this.businessGroupData[j].name
                  }
                  if (newData[i].accountType == 0) {
                    newData[i].IPContent = newData[i].account
                    newData[i].accountContent = ''
                  } else if (newData[i].accountType == 1) {
                    newData[i].IPContent = ''
                    newData[i].accountContent = newData[i].account
                  }
                }
              }
              this.tableList = newData
            } else {
              this.tableList = []
              this.totalNum = 0
            }
          }
        })
      },
      /*初始化数据*/
      initVisitorsIP() {
        let data = {
          companyId: this.userInfo.companyId,
          pageNum: this.currentPage,
          bizCodes:this.bizCodes,
        }
       this.getVisitorsIP(data)
      },
      /*新增数据*/
      addVisitorsIP() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          accountType: this.radioTxt,
          bizCode: this.businessGroupCode,
          account: this.radioContent,
          remark: this.contentTxt
        }
        apiDeployManagement.addConAccessLimit(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initVisitorsIP()
          }
        })
      },
      /*修改数据*/
      updateVisitorsIP() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          accountType: this.radioTxt,
          account: this.radioContent,
          bizCode: this.businessGroupCode,
          remark: this.contentTxt,
          id: this.resourceID
        }
        apiDeployManagement.updateConAccessLimit(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initVisitorsIP()
          }
        })
      },
      /*保存数据*/
      submitSave() {
        if (Util.isNotEmpty(this.contentTxt.replace(/\s/g, ''))) {
          if (this.resourceType == 0) {
            this.addVisitorsIP()
          } else if (this.resourceType == 1) this.updateVisitorsIP()
        }
      }
    },
    mounted() {
      this.initBusinessGroup()
      this.initVisitorsIP()
    }
  }
</script>

<style>
  .limitVisitorsIP .div_form .el-select{width: 100%}
</style>
